// src/components/owner-dashboard.js
import React from 'react';
import Sidebar from './Sidebar';
import '../App.css';
import '../responsive.css';

const OwnerDashboardPage = () => {
  return (
    <div className="DashboardPage">
      <header>Owner and Property Manager Dashboard</header>
      <Sidebar role="owner" />
      <div className="main-content">
        {/* Your main content goes here */}
      </div>
    </div>
  );
};

export default OwnerDashboardPage;
